var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fa)?_c('i',{class:`fa fa-${_vm.fa}`,attrs:{"aria-hidden":"true"}}):(_vm.fas)?_c('i',{class:`fas fa-${_vm.fas}`,attrs:{"aria-hidden":"true"}}):(_vm.far)?_c('i',{class:`far fa-${_vm.far}`,attrs:{"aria-hidden":"true"}}):_c('i',{class:`fab fa-${_vm.fab}`,attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }